import React from "react";

/** Pill button / link sizing shared by the Pre-EP screens; full width on phones. */
export const preEpButtonBase =
  "inline-flex min-h-[46px] w-full flex-none items-center justify-center gap-2 rounded-full px-5 py-2 text-center text-[15px] font-bold no-underline transition-colors hover:no-underline sm:w-auto sm:whitespace-nowrap";

export const preEpPrimaryButton =
  "bg-[#E0103F] text-white hover:bg-[#C40E37] hover:text-white";

export const preEpOutlineButton =
  "border border-white text-white hover:bg-white/10 hover:text-white";

export const preEpDisabledButton =
  "border border-[#3A4A7E] text-[#AEB8D3] cursor-not-allowed";

/** Card surface used for steps, events and sessions. */
export const preEpCard =
  "rounded-xl border border-[#23305A] bg-[#131F45] p-5 md:p-7";

export const ArrowIcon: React.FC = () => (
  <svg
    aria-hidden="true"
    fill="none"
    height="16"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2.2"
    viewBox="0 0 24 24"
    width="16"
  >
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

export const CheckIcon: React.FC<{ size?: number }> = ({ size = 20 }) => (
  <svg
    aria-hidden="true"
    fill="none"
    height={size}
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="3"
    viewBox="0 0 24 24"
    width={size}
  >
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  </svg>
);

/** The drifting blue and red glows behind the Pre-EP screens. */
export const PreEpGlows: React.FC = () => (
  <>
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -left-[10%] -top-[15%] h-[620px] w-[900px] rounded-full bg-[radial-gradient(closest-side,rgba(52,82,190,.45),rgba(52,82,190,0))] blur-[50px]"
    />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute -right-[12%] top-[40%] h-[560px] w-[720px] rounded-full bg-[radial-gradient(closest-side,rgba(224,16,63,.16),rgba(224,16,63,0))] blur-[50px]"
    />
  </>
);
